import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkalyaninagar() {



  const cardData = {



keyword: "Cab Service in Kalyani Nagar",

headingDescription: "Garud Cab Service provides comfortable and reliable Cab Service in Kalyani Nagar for corporate professionals, families, tourists, students, senior citizens, and groups looking for convenient local and outstation transportation. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for office travel, airport transfers, railway station pickups, corporate meetings, local transportation, one-way journeys, round trips, sightseeing, and customized outstation trips. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations across Kalyani Nagar, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes business and leisure travel smooth and convenient. Travelers can also arrange private cabs from Kalyani Nagar to hill stations, pilgrimage destinations, coastal getaways, major cities, and other outstation locations according to their preferred schedule.",

topPlaces: [
  {
    title: "Ujjain",
    description: "Ujjain is a major pilgrimage destination in Madhya Pradesh, famous for the Mahakaleshwar Temple and other important religious attractions. Families and devotees from Kalyani Nagar can choose a private chauffeur-driven cab for a comfortable long-distance journey. Garud Cab Service offers suitable vehicles with flexible one-way, round-trip, and customized pilgrimage travel options."
  },
  {
    title: "Goa",
    description: "Goa is a popular holiday destination known for beaches, forts, churches, markets, and scenic coastal landscapes. Couples, families, and groups from Kalyani Nagar can travel conveniently by private cab with door-to-door service. Customers can choose Sedan, SUV, Ertiga, Innova, or Innova Crysta for one-way, round-trip, or multi-day journeys."
  },
  {
    title: "Gokarna",
    description: "Gokarna combines peaceful beaches, coastal scenery, and important temples, making it an attractive destination for a longer road trip. Travelers from Kalyani Nagar can book a spacious private cab for comfortable travel with luggage. Garud Cab Service provides flexible multi-day itineraries and suitable vehicles for families and groups."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious and commercial destination known for temples, heritage attractions, vineyards, and scenic surroundings. Customers from Kalyani Nagar can arrange private cab transportation for pilgrimage, business visits, family travel, or sightseeing. Flexible one-way and round-trip options make it convenient to plan the journey around a preferred schedule."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a revered pilgrimage destination situated in the Sahyadri region and surrounded by forests and mountain scenery. Families and devotees from Kalyani Nagar can enjoy a direct private cab journey without changing vehicles. Customers can book comfortable vehicles with convenient pickup, temple travel, and return arrangements."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular Konkan getaway known for beaches, forts, resorts, and relaxing coastal surroundings. It is suitable for families and groups planning a weekend road trip from Kalyani Nagar. Garud Cab Service provides chauffeur-driven cabs with flexible sightseeing stops and one-way or round-trip travel arrangements."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is known for the Mahalaxmi Temple, historic attractions, traditional cuisine, and rich regional culture. Travelers from Kalyani Nagar can book a private cab for pilgrimage, business travel, family visits, or sightseeing. Spacious vehicles provide comfortable seating and practical luggage capacity for the longer journey."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station offering mountain viewpoints, waterfalls, lakes, valleys, and strawberry farms. Families and couples from Kalyani Nagar can plan a relaxing weekend trip with private chauffeur-driven transportation. Customers can customize their itinerary and combine Mahabaleshwar with Panchgani or nearby attractions."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad, officially known as Chhatrapati Sambhajinagar, is a major heritage destination with historic monuments, caves, temples, and cultural attractions. Tourists, families, and business travelers from Kalyani Nagar can arrange comfortable private cab transportation. Garud Cab Service provides flexible travel plans for sightseeing and longer outstation journeys."
  },
  {
    title: "Hyderabad",
    description: "Hyderabad is a major metropolitan and technology hub known for business districts, historic landmarks, cultural attractions, and food experiences. Corporate professionals and families from Kalyani Nagar can choose a private cab for a convenient long-distance journey. Innova and Innova Crysta options provide additional comfort and luggage space for extended travel."
  }
],




"services": [
{
"name": "Cab Service in Kalyani Nagar",
"description": "Cab Service in Kalyani Nagar provides convenient transportation for local travel, airport transfers, railway station drops, business trips, family journeys, and outstation destinations. Sedan, SUV, Ertiga, Innova, and other suitable vehicles can be arranged according to passenger and luggage requirements."
},
{
"name": "Cab Service in Kalyani Nagar Pune",
"description": "Cab Service in Kalyani Nagar Pune offers comfortable private transportation for residents, professionals, families, and visitors. Vehicles can be arranged for daily travel, airport pickups, local transfers, corporate requirements, sightseeing, and long-distance journeys."
},
{
"name": "Taxi Service in Kalyani Nagar",
"description": "Taxi Service in Kalyani Nagar is suitable for passengers looking for convenient transportation within Pune and nearby destinations. AC sedans, SUVs, Ertiga, and Innova options can be selected for individual, family, corporate, and group travel."
},
{
"name": "Taxi Service in Kalyani Nagar Pune",
"description": "Taxi Service in Kalyani Nagar Pune provides flexible transportation for office travel, shopping trips, airport transfers, railway station journeys, local rides, and outstation travel. Suitable vehicles can be arranged based on the destination, group size, and luggage."
},
{
"name": "Kalyani Nagar Cab Service",
"description": "Kalyani Nagar Cab Service offers private cab transportation for local and intercity journeys. The service can accommodate airport transfers, business travel, family trips, sightseeing, one-way drops, and round-trip requirements with different vehicle categories."
},
{
"name": "Kalyani Nagar Taxi Service",
"description": "Kalyani Nagar Taxi Service provides comfortable transportation for residents and visitors traveling across Pune and beyond. Sedan, SUV, Ertiga, and Innova vehicles can be arranged for local rides, airport travel, corporate transportation, and outstation journeys."
},
{
"name": "Cab Booking in Kalyani Nagar",
"description": "Cab Booking in Kalyani Nagar allows travelers to arrange transportation according to their preferred pickup time and destination. The service is suitable for airport transfers, railway station drops, local travel, business meetings, family trips, and outstation journeys."
},
{
"name": "Cabs in Kalyani Nagar Pune",
"description": "Cabs in Kalyani Nagar Pune provide convenient transportation for different travel requirements throughout the city and nearby destinations. Customers can choose practical sedans, spacious SUVs, Ertiga, Innova, or premium vehicles according to their journey."
},
{
"name": "Cab Near Me Kalyani Nagar",
"description": "Cab Near Me Kalyani Nagar helps passengers arrange nearby transportation for immediate or scheduled travel. Cabs can be used for local destinations, airport transfers, railway stations, office travel, shopping, family journeys, and outstation trips."
},
{
"name": "Taxi Near Me Kalyani Nagar",
"description": "Taxi Near Me Kalyani Nagar provides convenient access to private transportation for local and long-distance journeys. Comfortable AC vehicles can be arranged for individual passengers, families, corporate travelers, and groups."
},
{
"name": "Best Cab Service in Kalyani Nagar",
"description": "Best Cab Service in Kalyani Nagar is suitable for travelers seeking comfortable and dependable transportation for different types of journeys. Well-maintained vehicles can be arranged for airport transfers, corporate travel, family trips, sightseeing, and outstation routes."
},
{
"name": "Affordable Cab Service in Kalyani Nagar",
"description": "Affordable Cab Service in Kalyani Nagar provides practical transportation options for customers looking for convenient travel within Pune and to nearby cities. Vehicle choices can be matched with passenger requirements, travel distance, and journey type."
},
{
"name": "Reliable Taxi Service Kalyani Nagar",
"description": "Reliable Taxi Service Kalyani Nagar offers organized transportation for local rides, airport transfers, office travel, family journeys, and intercity trips. Customers can select suitable vehicles for individual travel, small families, or larger groups."
},
{
"name": "Outstation Cab Service in Kalyani Nagar",
"description": "Outstation Cab Service in Kalyani Nagar provides private transportation from Pune to destinations such as Mumbai, Shirdi, Nashik, Lonavala, Mahabaleshwar, Bhimashankar, Alibaug, Goa, and other cities. One-way and round-trip travel options can be arranged."
},
{
"name": "One-Way Cab from Kalyani Nagar",
"description": "One-Way Cab from Kalyani Nagar is suitable for passengers who need a private vehicle for a single-direction journey. The service can be arranged for airport transfers, intercity travel, family trips, business journeys, and outstation drops."
},
{
"name": "Round-Trip Cab from Kalyani Nagar",
"description": "Round-Trip Cab from Kalyani Nagar provides convenient transportation for return journeys where passengers travel to a destination and come back to Pune. It is suitable for sightseeing, family visits, business travel, temple trips, and weekend journeys."
},
{
"name": "Kalyani Nagar to Mumbai Cab",
"description": "Kalyani Nagar to Mumbai Cab provides private intercity transportation between Pune and Mumbai. Comfortable sedans, SUVs, Ertiga, and Innova vehicles can be arranged for business travel, family journeys, airport transfers, and personal trips."
},
{
"name": "Kalyani Nagar to Mumbai Airport Cab",
"description": "Kalyani Nagar to Mumbai Airport Cab offers convenient transportation for passengers traveling from Kalyani Nagar to Mumbai Airport. Suitable vehicles can be arranged according to flight schedules, passenger count, luggage requirements, and preferred pickup time."
},
{
"name": "Kalyani Nagar to Shirdi Cab",
"description": "Kalyani Nagar to Shirdi Cab provides private transportation for devotees and families traveling from Pune to Shirdi. Sedan, SUV, Ertiga, and Innova vehicles can be arranged for comfortable one-way or round-trip temple journeys."
},
{
"name": "Kalyani Nagar to Nashik Cab",
"description": "Kalyani Nagar to Nashik Cab offers convenient intercity travel for families, business travelers, and visitors heading toward Nashik. The service can be arranged for one-way drops, return journeys, sightseeing, and religious travel."
},
{
"name": "Kalyani Nagar to Lonavala Cab",
"description": "Kalyani Nagar to Lonavala Cab is suitable for weekend trips, family outings, sightseeing, and short leisure journeys. Comfortable AC cars can be arranged for couples, families, and groups traveling from Pune to Lonavala."
},
{
"name": "Kalyani Nagar to Mahabaleshwar Cab",
"description": "Kalyani Nagar to Mahabaleshwar Cab provides private transportation for travelers planning hill-station trips from Pune. Sedan, SUV, Ertiga, and Innova options can be arranged for families, couples, groups, and sightseeing requirements."
},
{
"name": "Kalyani Nagar to Bhimashankar Cab",
"description": "Kalyani Nagar to Bhimashankar Cab offers comfortable transportation for pilgrims and travelers visiting Bhimashankar. One-way and round-trip cab options can be arranged for temple visits, family trips, sightseeing, and weekend travel."
},
{
"name": "Kalyani Nagar to Alibaug Cab",
"description": "Kalyani Nagar to Alibaug Cab provides private transportation for coastal holidays, family outings, weekend trips, and sightseeing. Spacious vehicles can be arranged for individuals, families, and groups traveling from Pune to Alibaug."
},
{
"name": "Kalyani Nagar to Goa Cab",
"description": "Kalyani Nagar to Goa Cab provides long-distance private transportation for travelers planning a Goa holiday from Pune. Sedan, SUV, Ertiga, Innova, and larger vehicle options can be arranged for family trips, group travel, and extended journeys."
},
{
"name": "Outstation Cab Service in Wadgaon Sheri",
"description": "Outstation Cab Service in Wadgaon Sheri provides private transportation from Wadgaon Sheri to major destinations across Maharashtra and neighboring states. One-way and round-trip options can be arranged for families, business travelers, groups, and leisure trips."
},
{
"name": "One-Way Taxi in Wadgaon Sheri",
"description": "One-Way Taxi in Wadgaon Sheri is designed for passengers requiring a private vehicle for a single-direction journey. The service can be used for airport travel, railway stations, intercity drops, business trips, and outstation transportation."
},
{
"name": "Round-Trip Cab from Wadgaon Sheri",
"description": "Round-Trip Cab from Wadgaon Sheri provides convenient return transportation for travelers visiting another city or destination. It is suitable for sightseeing, family visits, pilgrimage trips, weekend travel, and business journeys."
},
{
"name": "Wadgaon Sheri to Mumbai Cab",
"description": "Wadgaon Sheri to Mumbai Cab offers comfortable private transportation between Pune and Mumbai. Suitable vehicles can be arranged for corporate travel, family journeys, personal visits, airport transfers, and other intercity requirements."
},
{
"name": "Wadgaon Sheri to Mumbai Airport Cab",
"description": "Wadgaon Sheri to Mumbai Airport Cab provides scheduled airport transportation for passengers traveling from Pune to Mumbai Airport. Cars can be arranged according to flight timing, luggage requirements, passenger count, and preferred vehicle category."
},
{
"name": "Wadgaon Sheri to Shirdi Cab",
"description": "Wadgaon Sheri to Shirdi Cab is suitable for devotees and families traveling to Shirdi for temple visits. Comfortable vehicles can be arranged for one-way drops, round trips, and customized pilgrimage travel."
},
{
"name": "Wadgaon Sheri to Nashik Cab",
"description": "Wadgaon Sheri to Nashik Cab provides private transportation for travelers heading to Nashik for business, family visits, sightseeing, and religious journeys. Sedan, SUV, Ertiga, and Innova options can be selected according to the group size."
},
{
"name": "Wadgaon Sheri to Lonavala Cab",
"description": "Wadgaon Sheri to Lonavala Cab offers comfortable transportation for weekend getaways and sightseeing trips. Private AC vehicles can be arranged for couples, families, and groups traveling from Pune toward Lonavala."
},
{
"name": "Wadgaon Sheri to Mahabaleshwar Cab",
"description": "Wadgaon Sheri to Mahabaleshwar Cab provides convenient private travel for hill-station holidays, family vacations, and weekend trips. Spacious sedan, SUV, Ertiga, and Innova vehicles can be arranged for different group requirements."
},
{
"name": "Wadgaon Sheri to Bhimashankar Cab",
"description": "Wadgaon Sheri to Bhimashankar Cab is suitable for temple visits, pilgrimage travel, family outings, and sightseeing. One-way and round-trip options can be arranged with comfortable vehicles for individuals, families, and groups."
},
{
"name": "Wadgaon Sheri to Alibaug Cab",
"description": "Wadgaon Sheri to Alibaug Cab provides private transportation for coastal trips, weekend holidays, family outings, and sightseeing. Customers can choose a suitable vehicle based on passenger count, luggage, and journey requirements."
},
{
"name": "Wadgaon Sheri to Kolhapur Cab",
"description": "Wadgaon Sheri to Kolhapur Cab offers long-distance transportation for business travel, family visits, pilgrimage journeys, and personal trips. Sedan, SUV, Ertiga, and Innova vehicles can be arranged for comfortable intercity travel."
},
{
"name": "Cab Service Near Yerawada",
"description": "Cab Service Near Yerawada provides convenient transportation for nearby residents, professionals, airport travelers, and visitors. Local rides, airport transfers, railway station drops, corporate travel, and outstation journeys can be arranged with suitable private vehicles."
}
],
"tableData": [
["Cab Service in Kalyani Nagar", "Cab Service in Kalyani Nagar Pune"],
["Taxi Service in Kalyani Nagar", "Taxi Service in Kalyani Nagar Pune"],
["Kalyani Nagar Cab Service", "Kalyani Nagar Taxi Service"],
["Cab Booking in Kalyani Nagar", "Cabs in Kalyani Nagar Pune"],
["Cab Near Me Kalyani Nagar", "Taxi Near Me Kalyani Nagar"],
["Best Cab Service in Kalyani Nagar", "Affordable Cab Service in Kalyani Nagar"],
["Reliable Taxi Service Kalyani Nagar", "Outstation Cab Service in Kalyani Nagar"],
["One-Way Cab from Kalyani Nagar", "Round-Trip Cab from Kalyani Nagar"],
["Kalyani Nagar to Mumbai Cab", "Kalyani Nagar to Mumbai Airport Cab"],
["Kalyani Nagar to Shirdi Cab", "Kalyani Nagar to Nashik Cab"],
["Kalyani Nagar to Lonavala Cab", "Kalyani Nagar to Mahabaleshwar Cab"],
["Kalyani Nagar to Bhimashankar Cab", "Kalyani Nagar to Alibaug Cab"],
["Kalyani Nagar to Goa Cab", "Outstation Cab Service in Wadgaon Sheri"],
["One-Way Taxi in Wadgaon Sheri", "Round-Trip Cab from Wadgaon Sheri"],
["Wadgaon Sheri to Mumbai Cab", "Wadgaon Sheri to Mumbai Airport Cab"],
["Wadgaon Sheri to Shirdi Cab", "Wadgaon Sheri to Nashik Cab"],
["Wadgaon Sheri to Lonavala Cab", "Wadgaon Sheri to Mahabaleshwar Cab"],
["Wadgaon Sheri to Bhimashankar Cab", "Wadgaon Sheri to Alibaug Cab"],
["Wadgaon Sheri to Kolhapur Cab", "Cab Service Near Yerawada"]
]
,



whychoose: [
  {
    WhyChooseheading: "Cab Service in Kalyani Nagar for Local & Business Travel",
    WhyChoosedescription: "Private cab transportation in Kalyani Nagar is a convenient option for residents, corporate professionals, families, tourists, and visitors travelling to offices, hotels, restaurants, airports, railway stations, and outstation destinations."
  },
  {
    WhyChooseheading: "Pickup from Your Preferred Kalyani Nagar Location",
    WhyChoosedescription: "Passengers can arrange pickup from their home, apartment, hotel, office, residential society, commercial location, or another accessible point in Kalyani Nagar according to their travel plans."
  },
  {
    WhyChooseheading: "Ideal for Corporate & Professional Travel",
    WhyChoosedescription: "Business travellers can use private cabs for office commutes, client meetings, conferences, corporate events, business appointments, and transportation between Kalyani Nagar and other commercial areas."
  },
  {
    WhyChooseheading: "Airport & Railway Station Transfers",
    WhyChoosedescription: "A private cab can be arranged for travel from Kalyani Nagar to Pune Airport, Pune Railway Station, and other transport points, offering direct transportation for passengers travelling with luggage."
  },
  {
    WhyChooseheading: "Comfortable for Families & Groups",
    WhyChoosedescription: "Families, couples, and groups can select a suitable vehicle according to passenger count, luggage requirements, journey distance, and preferred comfort level for both local and longer trips."
  },
  {
    WhyChooseheading: "Useful for Everyday Pune Transportation",
    WhyChoosedescription: "Kalyani Nagar cab services can be used for shopping trips, hotel transfers, restaurant visits, hospital appointments, residential travel, business locations, and other destinations across Pune."
  },
  {
    WhyChooseheading: "One-Way & Outstation Cab Options",
    WhyChoosedescription: "Travellers can arrange one-way or round-trip cabs from Kalyani Nagar to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Satara, Goa, and other preferred cities."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Kalyani Nagar pickup point, destination, travel date, passenger count, luggage details, preferred vehicle, and local or outstation requirement with Garud Cab Service for suitable booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Cab Service in Kalyani Nagar?",
    answer: "Yes, Garud Cab Service provides private cab services in Kalyani Nagar for local travel, corporate transportation, airport transfers, railway station travel, family trips, sightseeing, and outstation journeys."
  },
  {
    question: "Can I book a cab from anywhere in Kalyani Nagar?",
    answer: "Yes, pickup can be arranged from a preferred accessible location in Kalyani Nagar, including homes, apartments, offices, hotels, residential societies, and commercial locations."
  },
  {
    question: "Can I book a cab from Kalyani Nagar to Pune Airport?",
    answer: "Yes, private airport transfer services can be arranged from Kalyani Nagar to Pune Airport according to your preferred travel date and flight schedule."
  },
  {
    question: "Can I book a cab from Kalyani Nagar to Pune Railway Station?",
    answer: "Yes, a private cab can be arranged for direct transportation from Kalyani Nagar to Pune Railway Station or another preferred railway station location."
  },
  {
    question: "Is Kalyani Nagar Cab Service suitable for corporate travel?",
    answer: "Yes, business travellers and companies can arrange private cabs for office visits, client meetings, conferences, corporate events, business appointments, and other professional transportation needs."
  },
  {
    question: "Does the service provide outstation cabs from Kalyani Nagar?",
    answer: "Yes, one-way and round-trip outstation cabs can be arranged from Kalyani Nagar to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Satara, Goa, and other cities."
  },
  {
    question: "Is the Kalyani Nagar cab service suitable for families?",
    answer: "Yes, families and groups can select a suitable vehicle based on passenger numbers, luggage requirements, journey distance, and preferred comfort level."
  },
  {
    question: "Can I book a one-way cab from Kalyani Nagar?",
    answer: "Yes, one-way cab service can be arranged when you need direct transportation from Kalyani Nagar to your preferred destination without requiring the same vehicle for the return journey."
  },
  {
    question: "Can I carry luggage in a Kalyani Nagar cab?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger or additional baggage requirements should be communicated during booking."
  },
  {
    question: "How can I book a Cab Service in Kalyani Nagar?",
    answer: "Share your Kalyani Nagar pickup location, destination, travel date, passenger details, luggage requirements, preferred vehicle, and local or outstation travel requirement with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Varun Mehta",
    feedback: "I needed a private cab in Kalyani Nagar for a series of business meetings across Pune. The direct pickup and comfortable travel made it easier to stay on schedule throughout the day.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "We arranged a cab from Kalyani Nagar for an airport transfer with our family and luggage. The private vehicle made the journey simple and convenient for everyone.",
    rating: 5
  }
];




  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kalyani Nagar",
  "image": "https://garudcabs.com/assets/images/cab-service-in-kalyani-nagar.webp",
  "description": "Book Cab Service in Kalyani Nagar with Garud Cab for safe, comfortable, and reliable local, airport, corporate, and outstation transportation. Get taxi and cab booking services in Kalyani Nagar Pune for daily commuting, business travel, airport transfers, family journeys, sightseeing, and intercity trips. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles with convenient pickup and drop facilities and flexible one way or round trip options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/cab-service-in-kalyani-nagar"
  }
};



  return (
    <div>


<Helmet>
  <title>Cab Service in Kalyani Nagar | Taxi & Cab Booking | +91 9970007784</title>

  <meta
    name="description"
    content="Book Cab Service in Kalyani Nagar Pune with Garud Cab for reliable local, airport, corporate, and outstation travel. Get taxi and cab booking services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Cab Service in Kalyani Nagar, Cab Service in Kalyani Nagar Pune, Taxi Service in Kalyani Nagar, Taxi Service in Kalyani Nagar Pune, Kalyani Nagar Cab Service, Kalyani Nagar Taxi Service, Cab Booking in Kalyani Nagar, Cabs in Kalyani Nagar, Best Cab Service in Kalyani Nagar, Kalyani Nagar Outstation Cab, Kalyani Nagar Airport Cab, Kalyani Nagar Local Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/112.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinkalyaninagar;